import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image,TouchableOpacity, SafeAreaView, ScrollView  } from 'react-native'
import { WebView } from 'react-native-webview';
import Modal from "react-native-modal";
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';


const GeneratedElelemntSublist = ({  text, sublist }) => {

    const tailwind = useTailwind();
    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = (number) => {
        console.log("activate view ",number)
        setModalVisible(!isModalVisible);
    };

    console.log("Elelemento de sublista")
    console.log(text)
    console.log(sublist)

    return (
        <View style ={ tailwind("") }>
            {
                text != "" ?
                    <Text style={tailwind("text-justify my-2 whitespace-normal")}>- {text["esp"]} </Text> 
                :
                    null 
            }
           
        </View>
    )

 

}

export default GeneratedElelemntSublist